import {get, post, postExport} from '../index'
export default {
  // 获取活动分类列表
  getActivityClassifyList(querys) {
    return get('/activity/admin/activityClassifyAdmin/listAll', querys)
  },
  // 添加活动分类详情
  addActivityClassifyInfo(querys) {
    return post('/activity/admin/activityClassifyAdmin/createActivityClassify', querys)
  },
  // 编辑活动分类详情
  editActivityClassifyInfo(querys) {
    return post('/activity/admin/activityClassifyAdmin/updateActivityClassify', querys)
  },
  // 上下架、删除活动分类信息
  updateActivityClassifyInfo(querys) {
    return post('/activity/admin/activityClassifyAdmin/changeStatus', querys)
  },
  // 删除活动分类信息
  delActivityClassify(querys) {
    return post('/activity/admin/activityClassifyAdmin/changeStatus', querys)
  },
  // 报名内容列表
  getActivityContentList(querys) {
    return get('/activity/admin/activityItemAdmin/listAllWithPage', querys)
  },
  // 添加报名内容
  addActivityContentInfo(querys) {
    return post('/activity/admin/activityItemAdmin/createOne', querys)
  },
  // 编辑报名内容
  editActivityContentInfo(querys) {
    return post('/activity/admin/activityItemAdmin/updateOne', querys)
  },
  // 上下架报名内容
  updateActivityContentInfo(querys) {
    return post('/activity/admin/activityItemAdmin/changeStatus', querys)
  },
  // 活动管理列表
  getActivityManageList(querys) {
    return get('/activity/admin/activityAdmin/listAll', querys)
  },
  // 添加活动信息
  addActivityInfo(querys) {
    return post('/activity/admin/activityAdmin/createOne', querys)
  },
  // 编辑活动信息
  editActivityInfo(querys) {
    return post('/activity/admin/activityAdmin/updateOne', querys)
  },
  updateActivityInfo(querys) {
    return post('/activity/admin/activityAdmin/changeStatus', querys)
  },
  // 活动信息回显
  getActivityInfo(querys) {
    return get('/activity/admin/activityAdmin/getOne', querys)
  },
  // 创建活动小程序码
  createActivityQrcode(querys) {
    return post('/activity/admin/activityAdmin/createQrCode', querys)
  },
  // 批量导出活动
  batchExportActivity(querys) {
    return get('/activity/admin/activityAdmin/activityExcel', querys)
  },
  // 获取活动编辑页面下拉分类
  getActivityListAllForSelect() {
    return get('/activity/admin/activityClassifyAdmin/listAllForSelect')
  },
  // 获取活动报名及页面下拉的报名内容
  getActivityAllNoPage() {
    return get('/activity/admin/activityItemAdmin/getAllNoPage')
  },
  // 获取报名情况列表表头
  getActivitySignUpHeader(querys) {
    return get('/activity/admin/activityUserRecordAdmin/getTableHead', querys)
  },
  // 获取报名情况列表数据
  getActivitySignUpList(querys) {
    return get('/activity/admin/activityUserRecordAdmin/listByActivity', querys)
  },
  // 获取用户报名情况
  getUserManageList(querys) {
    return get('/activity/admin/activityUserManage/list', querys)
  },
  // 获取用户报名情况列表
  getUserActivityList(querys) {
    return get('/activity/admin/activityUserManage/activityList', querys)
  },
  // 设置用户是否拉黑
  setUserBlack(querys) {
    return get('/activity/admin/activityUserManage/setBlack', querys)
  },
  // 批量导出人员管理
  batchExportUserManage(querys) {
    return get('/activity/admin/activityUserManage/activityExcel', querys)
  },
  // 活动组管理列表
  getActivityGroupManageList(querys) {
    return get('/activity/admin/activityAdminGroup/listAll', querys)
  },
  // 添加活动组信息
  addActivityGroupInfo(querys) {
    return post('/activity/admin/activityAdminGroup/createOne', querys)
  },
  // 编辑活动组信息
  editActivityGroupInfo(querys) {
    return post('/activity/admin/activityAdminGroup/updateOne', querys)
  },
  updateActivityGroupInfo(querys) {
    return post('/activity/admin/activityAdminGroup/changeStatus', querys)
  },
  // 活动组信息回显
  getActivityGroupInfo(querys) {
    return get('/activity/admin/activityAdminGroup/getOne', querys)
  },
  // 创建活动组小程序码
  createActivityGroupQrcodeList(querys) {
    return post('/activity/admin/activityAdminGroup/createQrCode', querys)
  },
  // 获取全部活动组
  getActivityGroupAll(querys) {
    return get('/activity/admin/activityAdmin/groupList', querys)
  },
  // 获取活动历史版本
  getActivityVersionList(querys) {
    return get('/activity/admin/activityAdmin/versionList', querys)
  },
  // 获取活动历史版本
  getActivityZip(querys) {
    return get('/activity/admin/activityAdmin/activityZip', querys)
  },
  //导入
  importActivity(querys) {
    return post('/activity/admin/activityAdmin/importActivity', querys)
  },
  //高级搜索
  getActivitydetailedSearchList(querys){
    return post('/activity/admin/activityAdmin/detailedSearchList', querys)
  },
  //批量修改
  updateBatchActivity(querys){
    return post('/activity/admin/activityAdmin/updateBatch', querys)
  },
  //异常活动列表
  getActivityAbList (querys){
    return post('/activity/admin/activityAdmin/abnormalList', querys)
  },
  // 获取报名情况列表数据(异常)
  getActivitySignUpAbList (querys) {
    return post('/activity/admin/activityUserRecordAdmin/abnormalRecord', querys)
  },
  // 批量重置海报(检查)
  batchReproduceQrCodeCheck (querys) {
    return post('/activity/admin/activityAdmin/reproduceQrCodeCheck', querys)
  },// 批量重置海报
  batchReproduceQrCodeStop (querys) {
    return post('/activity/admin/activityAdmin/reproduceQrCodeStop', querys)
  },// 批量重置海报
  batchReproduceQrCodeRestart (querys) {
    return post('/activity/admin/activityAdmin/reproduceQrCodeRestart', querys)
  },
  // 批量重置活动
  batchResetActivity (querys) {
    return post('/activity/admin/activityAdmin/resetActivity', querys)
  },
  // 高级导出
  advancedExportActivity (querys) {
    return postExport('/activity/admin/activityAdmin/advancedExport', querys)
  },
  // 高级导出
  abRepeatByAddress (querys) {
    return postExport('/activity/admin/activityAdmin/abRepeatByAddress', querys)
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/activity.js